// removed by extract-text-webpack-plugin
module.exports = {"headingLink":"_1a2OJzF","heading":"_29hG8gf","noItems_highlight":"_3w-bMJI","icon":"_2Hs3Jxj","items":"_3ExGWz3","noItems":"_2ryHU2f","viewAll":"_1mA2vHy","chevron":"MyN3cuQ","chevronSvg":"vAwo85G","iconSvg":"_17PoVEe"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/SavedSearchesDashboard/SavedSearchesDashboard.less
 ** module id = 767
 ** module chunks = 0
 **/